module.exports = __webpack_public_path__ + "static/media/bz.2458dd8a.svg";